import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ButtonsModule } from 'ngx-bootstrap/buttons';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CommonModalComponent } from '@shared/components/modal/common-modal/common-modal.component';
import { LinkyModule } from 'ngx-linky';
import { NgymDropdownModule } from 'ngym-dropdown';
import { AngularMyDatePickerModule } from '@nodro7/angular-mydatepicker';
import { DateTimeRangePickerComponent } from '@shared/components/date-time-range-picker/date-time-range-picker.component';
import { ModalGenericComponent } from '@shared/components/modal/modal-generic/modal-generic.component';
import { TranslateModule } from '@ngx-translate/core';
import { EpochDetailPipe } from '@shared/pipes/epochDetail/epochDetail.pipe';
import { SpinnerComponent } from '@shared/components/spinner/spinner.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsModalRef, ModalModule } from 'ngx-bootstrap/modal';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { ToastrModule } from 'ngx-toastr';
import { SanitizeAndEncodeHtmlPipe } from '@shared/pipes/sanitizeAndEncodeHtml.pipe';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { FileTypeImageDirective } from '@shared/directives/fileTypeImage/fileTypeImage.directive';
import { FileSizePipe } from '@shared/pipes/file-size.pipe';
import { AttachmentViewer } from '@shared/components/attachment-viewer/attachment-viewer.component';
import { AppendToBodyDirective } from '@shared/directives/append-to-body.directive';
import { SkeletonLoaderPolicyComponent } from '@shared/components/skeleton-loaders/shared/policy/skeleton-loader-policy.component';
import { CircleLoaderComponent } from '@shared/components/circle-loader/circle-loader.component';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgOptimizedImage,
    ButtonsModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ModalModule.forRoot(),
    TimepickerModule.forRoot(),
    ToastrModule.forRoot({ preventDuplicates: true, maxOpened: 1, autoDismiss: true }),
    BsDropdownModule.forRoot(),
    ButtonsModule.forRoot(),
    TooltipModule.forRoot(),
    AngularMyDatePickerModule,
    LinkyModule,
    NgymDropdownModule,
    NgxExtendedPdfViewerModule,
    SkeletonLoaderPolicyComponent,
  ],

  declarations: [
    SanitizeAndEncodeHtmlPipe,
    EpochDetailPipe,
    SpinnerComponent,
    CircleLoaderComponent,
    CommonModalComponent,
    ModalGenericComponent,
    DateTimeRangePickerComponent,
    FileSizePipe,
    FileTypeImageDirective,
    AttachmentViewer,
    AppendToBodyDirective,
  ],
  exports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgOptimizedImage,
    BsDropdownModule,
    ButtonsModule,
    TooltipModule,
    TimepickerModule,
    BsDatepickerModule,
    AngularMyDatePickerModule,
    LinkyModule,
    NgymDropdownModule,
    ModalModule,
    SkeletonLoaderPolicyComponent,
    SanitizeAndEncodeHtmlPipe,
    EpochDetailPipe,
    SpinnerComponent,
    CircleLoaderComponent,
    CommonModalComponent,
    ModalGenericComponent,
    DateTimeRangePickerComponent,
    FileSizePipe,
    FileTypeImageDirective,
    NgxExtendedPdfViewerModule,
    AttachmentViewer,
    AppendToBodyDirective,
  ],
  providers: [BsModalRef],
})
// https://github.com/ocombe/ng2-translate/issues/209
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
    };
  }
}
